import * as React from 'react'
import { Loader } from '../loader'
import { Border } from './border'

export interface IProps {
  length: number
  isLoading?: boolean
}
export const MutlipleItemsSelected: React.FCC<IProps> = ({
  length,
  isLoading = false,
}) => (
  <div className="flex relative justify-center">
    <div className="stroke-secondary translate-x-[-5px] translate-y-[-6px]">
      <Border />
    </div>
    <div className="absolute inset-0 flex items-baseline justify-center translate-x-[7px] translate-y-[7px] stroke-gray-300">
      <Border />
    </div>
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="flex flex-col gap-1 items-center">
        <div className="flex flex-row gap-1 justify-center">
          {isLoading ? <Loader size={16} /> : <FrameIcon />}
          <p className="text-xs font-semibold text-black/80">{`${length} frames`}</p>
        </div>
        <p className="text-xs font-normal text-black/80">{`selected`}</p>
      </div>
    </div>
  </div>
)

MutlipleItemsSelected.displayName = 'MutlipleItemsSelected'

const FrameIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4H14M2 12H14M4 2V14M12 2V14"
      stroke="black"
      strokeOpacity="0.8"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
